module.exports = "/_next/static/images/screen-consultation-2-3356d930f9543492a4e4b32a3b9c5bbf.png";